import { ACTION_TYPES, patchInvoiceFailure } from "../actions"
import { ofType } from "redux-observable"
import { catchError, from, map, mergeMap, of } from "rxjs"
import { InvoiceService } from "../services"
import { patchInvoiceSuccess } from "../actions"

export const patchInvoiceEpic = (action$) => action$.pipe(
    ofType(ACTION_TYPES.PATCH_INVOICE),
    mergeMap(({payload}) => {
        return from(InvoiceService.patch(payload.id, payload.payload))
            .pipe(
                map(patchInvoiceSuccess),
                catchError(() => of(patchInvoiceFailure))
            )
    }))




// WEBPACK FOOTER //
// ./src/state/invoice/epics/epics.ts